import { Component, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-delivery-window',
  templateUrl: './delivery-window.component.html',
  styleUrls: ['./delivery-window.component.scss'],
})
export class DeliveryWindowComponent implements OnInit {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public _data: any,
    public _bottomSheetRef: MatBottomSheetRef<DeliveryWindowComponent>) {
    
    }

  ngOnInit(): void { }
  
  
}
